const loadBookmarkPageDuck = () =>
  import('./BookmarkPage/BookmarkPage.duck').then((module) => ({ loadData: module.loadData }));
const loadCalendarPageDuck = () =>
  import('./CalendarPage/CalendarPage.duck').then((module) => ({ loadData: module.loadData }));
const loadCheckoutPageDuck = () =>
  import('./CheckoutPage/CheckoutPage.duck').then((module) => ({
    loadData: module.loadData,
    setInitialValues: module.setInitialValues,
  }));
const loadContactSettingsPageDuck = () =>
  import('./ContactSettingsPage/ContactSettingsPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadDeleteUserPageDuck = () =>
  import('./DeleteUserPage/DeleteUserPage.duck').then((module) => ({ loadData: module.loadData }));
const loadDumpStationSearchPageDuck = () =>
  import('./DumpStationSearchPage/DumpStationSearchPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadDumpStationPageDuck = () =>
  import('./DumpStationPage/DumpStationPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadEditListingPageDuck = () =>
  import('./EditListingPage/EditListingPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadEmailVerificationPageDuck = () =>
  import('./EmailVerificationPage/EmailVerificationPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadInboxPageDuck = () =>
  import('./InboxPage/InboxPage.duck').then((module) => ({ loadData: module.loadData }));
const loadLandingPageDuck = () =>
  import('./LandingPage/LandingPage.duck').then((module) => ({ loadData: module.loadData }));
const loadListingPageDuck = () =>
  import('./ListingPage/ListingPage.duck').then((module) => ({ loadData: module.loadData }));
const loadManageListingsPageDuck = () =>
  import('./ManageListingsPage/ManageListingsPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadPassSettingsPageDuck = () =>
  import('./PassSettingsPage/PassSettingsPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadPaymentMethodsPageDuck = () =>
  import('./PaymentMethodsPage/PaymentMethodsPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadProfilePageDuck = () =>
  import('./ProfilePage/ProfilePage.duck').then((module) => ({ loadData: module.loadData }));
const loadSearchPageDuck = () =>
  import('./SearchPage/SearchPage.duck').then((module) => ({ loadData: module.loadData }));
const loadSigninPageDuck = () =>
  import('./SigninPage/SigninPage.duck').then((module) => ({ loadData: module.loadData }));
const loadSignupPageDuck = () =>
  import('./SignupPage/SignupPage.duck').then((module) => ({ loadData: module.loadData }));
const loadStoryblokPageDuck = () =>
  import('./StoryblokPage/StoryblokPage.duck').then((module) => ({ loadData: module.loadData }));
const loadStripePayoutPageDuck = () =>
  import('./StripePayoutPage/StripePayoutPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadTransactionPageDuck = () =>
  import('./TransactionPage/TransactionPage.duck').then((module) => ({
    loadData: module.loadData,
    setInitialValues: module.setInitialValues,
  }));
const loadNotificationSettingsPageDuck = () =>
  import('./NotificationSettingsPage/NotificationSettingsPage.duck').then((module) => ({
    loadData: module.loadData,
  }));
const loadLoyaltyProgrammePageDuck = () =>
  import('./LoyaltyProgrammePage/LoyaltyProgrammePage.duck').then((module) => ({
    loadData: module.loadData,
  }));

const getPageDataLoadingAPI = () => {
  return {
    BookmarkPage: {
      loadDuck: loadBookmarkPageDuck,
    },
    CalendarPage: {
      loadDuck: loadCalendarPageDuck,
    },
    CheckoutPage: {
      loadDuck: loadCheckoutPageDuck,
    },
    ContactSettingsPage: {
      loadDuck: loadContactSettingsPageDuck,
    },
    DeleteUserPage: {
      loadDuck: loadDeleteUserPageDuck,
    },
    DumpStationSearchPage: {
      loadDuck: loadDumpStationSearchPageDuck,
    },
    DumpStationPage: {
      loadDuck: loadDumpStationPageDuck,
    },
    EditListingPage: {
      loadDuck: loadEditListingPageDuck,
    },
    EmailVerificationPage: {
      loadDuck: loadEmailVerificationPageDuck,
    },
    InboxPage: {
      loadDuck: loadInboxPageDuck,
    },
    LandingPage: {
      loadDuck: loadLandingPageDuck,
    },
    ListingPage: {
      loadDuck: loadListingPageDuck,
    },
    ManageListingsPage: {
      loadDuck: loadManageListingsPageDuck,
    },
    PassSettingsPage: {
      loadDuck: loadPassSettingsPageDuck,
    },
    PaymentMethodsPage: {
      loadDuck: loadPaymentMethodsPageDuck,
    },
    ProfilePage: {
      loadDuck: loadProfilePageDuck,
    },
    LoyaltyProgrammePage: {
      loadDuck: loadLoyaltyProgrammePageDuck,
    },
    SearchPage: {
      loadDuck: loadSearchPageDuck,
    },
    SigninPage: {
      loadDuck: loadSigninPageDuck,
    },
    SignupPage: {
      loadDuck: loadSignupPageDuck,
    },
    StripePayoutPage: {
      loadDuck: loadStripePayoutPageDuck,
    },
    TransactionPage: {
      loadDuck: loadTransactionPageDuck,
    },
    StoryblokPage: {
      loadDuck: loadStoryblokPageDuck,
    },
    NotificationSettingsPage: {
      loadDuck: loadNotificationSettingsPageDuck,
    },
  };
};

export default getPageDataLoadingAPI;
